import React, { useEffect, useState } from 'react';
import Header from '../../componets/header/header';
import Footer from '../../componets/footer/footer';
import courseback from "../../../assets/course-back.jpg";
import { useParams } from 'react-router-dom';
import { GET, POST } from '../../../utils/apicalls';
import { API } from '../../../config/api';
import { App, Button, Col, Form, Input, Modal, Row, Tabs } from 'antd';

// @ts-ignore: CSS side-effect import without declaration file
import './commonCourse.css';
import EligibilityCheckForm from '../eligibilitycheckForm';
import course1 from "../../../assets/course1.webp";
import course2 from "../../../assets/eligibility_check.webp";
import course3 from "../../../assets/course2.webp";
import course4 from "../../../assets/course3.webp";
import defalut from "../../../assets/fixed_mage.png";
import EnrollModal from '../../booking-payment/enrollmentModel';
import why1 from '../../../assets/why1.webp';
import whycfe from '../../../assets/course2.webp';
import FormItem from 'antd/es/form/FormItem';

import CourseDisplayCard from './courseDisplayCard';
function Cams() {
    const { id } = useParams();
    const [form] = Form.useForm();
    const { notification } = App.useApp();
    const [courseDetails, setCourseDetails] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    // const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('eligibility');
    const [isEligibilityModalOpen, setIsEligibilityModalOpen] = useState(false);
    const [selectedCourseForEnroll, setSelectedCourseForEnroll] = useState<string | number | null>(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const submitHandler = async (values: any) => {
        try {
            let obj = {
                name: values.name,
                email: values.email,
                message: values.message,
                phone: values.phone,
                Course_id: Number(id),
            };

            setIsLoading(true);
            const postRequest: any = await POST(API.CREATE_COURSE_ENQUIRY, obj);

            if (postRequest) {
                notification.success({ message: "Message sent successfully!" });
                form.resetFields();
            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {
            console.error(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };
    const tabItems = [
        {
            key: 'eligibility',
            label: <div className="tab-label">Eligibility Check</div>,
            children: (
                <div className="tab-content eligibility-tab">
                    <div className="tab-text">
                        <h2>Eligibility Check</h2>
                        <ul>
                            <li>Minimum <strong>40 Eligibility Credits</strong> as per ACAMS requirements</li>
                            <li>Eligibility is based on <strong>Education, Professional Experience, and Professional Training</strong></li>
                            <li>Bachelor's or Master's degree holders can earn eligibility credits</li>
                            <li>Relevant experience in <strong>AML, KYC, Compliance, Risk Management, Banking, Audit, Financial Crime, Law Enforcement, Fraud Prevention, or Regulatory Compliance</strong> is accepted</li>
                            <li>Professional AML training and industry certifications contribute additional eligibility credits</li>
                            <li>Active <strong>ACAMS Membership</strong> is required to apply for the CAMS examination</li>
                        </ul>

                    </div>
                    <div className="tab-image">
                        <img src={course2} alt="CAMS certification India" />
                    </div>
                </div>

            ),
        },
        {
            key: 'exam',
            label: <div className="tab-label">Pattern and Scoring</div>,
            children: (
                <div className="tab-content exam-tab">
                    <div className="tab-text">
                        <ul>
                            <li><strong>Exam Format:</strong> Multiple Choice Questions (MCQs)</li>
                            <li><strong>Total Questions:</strong> 120 Questions</li>
                            <li><strong>Exam Duration:</strong> 3.5 Hours (210 Minutes)</li>
                            <li><strong>Passing Score:</strong> Scaled Score of 75%</li>
                            <li><strong>Mode of Examination:</strong> Online Proctored or Pearson VUE Test Center</li>
                            <li><strong>Question Type:</strong> Practical and scenario-based questions focused on real-world AML compliance</li>
                            <li><strong>Negative Marking:</strong> No Negative Marking</li>
                            <li><strong>Result:</strong> Pass/Fail</li>
                        </ul>
                        <p>
                            The CAMS examination evaluates your knowledge across key Anti-Money Laundering domains, including <strong>AML Regulations, KYC, CDD, EDD, Transaction Monitoring, Sanctions Compliance, Suspicious Activity Reporting (SAR), Terrorist Financing, FATF Recommendations, and AML Compliance Programs.</strong>
                        </p>
                    </div>
                    <div className="tab-image">
                        <img src={course1} alt="CAMS certification India" />
                    </div>
                </div>

            ),
        },

        {
            key: 'outcomes',
            label: <div className="tab-label">Career Opportunities</div>,
            children: (
                <div className="tab-content outcomes-tab">
                    <div className="tab-text">
                        <h3>CAMS unlocks careers in:</h3>
                        <ul>
                            <li>Anti-Money Laundering (AML) Analyst</li>
                            <li>AML Compliance Officer</li>
                            <li>KYC / CDD / EDD Analyst</li>
                            <li>Transaction Monitoring Analyst</li>
                            <li>Sanctions Screening Analyst</li>
                            <li>Financial Crime Analyst</li>
                            <li>AML Investigator</li>
                            <li>Suspicious Activity Reporting (SAR) Analyst</li>
                            <li>Regulatory Compliance Officer</li>
                            <li>Risk & Compliance Analyst</li>
                            <li>Financial Intelligence Analyst</li>
                            <li>Compliance Manager</li>
                            <li>AML Quality Assurance (QA) Analyst</li>
                            <li>AML Team Lead</li>
                            <li>Financial Crime Compliance Specialist</li>
                            <li>AML Consultant</li>
                        </ul>
                        <p>
                            <strong>Top Hiring Sectors:</strong> Global Banks, Investment Banks, FinTech Companies, Big 4 Firms, MNCs, NBFCs, Insurance Companies, Payment Service Providers, Cryptocurrency & Virtual Asset Companies (VASPs), Consulting Firms, Regulatory Authorities, and Global Capability Centers (GCCs).
                        </p>
                    </div>
                    <div className="tab-image">
                        <img src={course3} alt="CAMS certification India" />
                    </div>
                </div>

            ),
        },
        {
            key: 'target-audiance',
            label: <div className="tab-label">CAMS Exam Cost</div>,
            children: (
                <div className="tab-content outcomes-tab">
                    <div className="tab-text">
                        <ul>
                            <li>
                                <strong>Private Sector Members:</strong> Starts from USD $1,995 (includes ACAMS Membership & Exam Package)
                            </li>
                            <li>
                                <strong>Public Sector Members:</strong> Discounted pricing available
                            </li>
                            <li>
                                <strong>Exam Package Includes:</strong>
                                <ul>
                                    <li>1-Year ACAMS Membership</li>
                                    <li>Digital CAMS Study Guide</li>
                                    <li>Practice Questions</li>
                                    <li>Online Learning Resources</li>
                                    <li>CAMS Examination</li>
                                </ul>
                            </li>
                            <li>
                                <strong>Exam Retake Fee:</strong> Additional charges apply as per ACAMS policy.
                            </li>
                            <li>
                                <strong>Recertification:</strong> Every 3 years through Continuing Education (CE) Credits and renewal requirements.
                            </li>
                        </ul>

                        <p>
                            <strong>Note:</strong> CAMS fees are subject to revision by ACAMS. Contact Meantoir Global Academy, Kochi for the latest pricing, membership guidance, and enrollment support.
                        </p>
                    </div>
                    <div className="tab-image">
                        <img src={course4} alt="CAMS course Kerala" />
                    </div>
                </div>
            ),
        },


    ];
    useEffect(() => {
        const fetchCourseDetails = async () => {
            setIsLoading(true);
            try {
                const response: any = await GET(`${API.GET_COURSE_BY_ID}${id}`, {});
                setCourseDetails(response?.data);
                console.log("Course Response:", response);
            } catch (error) {
                console.error("Error fetching course details:", error);
            } finally {
                setIsLoading(false);
            }
        };

        if (id) {
            fetchCourseDetails();
        }
    }, [id]);
    const [openSection, setOpenSection] = useState<string | null>(null);

    const toggleSection = (section: string) => {
        setOpenSection(prev => (prev === section ? null : section));
    };

    // Update the showModal function
    const showModal = (courseId: string | number, e: React.MouseEvent) => {
        e.stopPropagation(); // Stop event propagation to prevent navigation
        setSelectedCourseForEnroll(courseId);
        setIsModalVisible(true);
    };

    // Update the handleCloseModal function
    const handleCloseModal = () => {
        setIsModalVisible(false);
        setSelectedCourseForEnroll(null); // Reset selected course when closing
    };

    const whycamstexts = [
        <>World's leading <strong>Anti-Money Laundering (AML) certification</strong> recognized by employers across <strong>180+ countries and territories</strong>.</>,

        <>Trusted by <strong>100,000+ AML and Financial Crime professionals worldwide</strong>.</>,

        <>Preferred qualification for careers in <strong>Global Banks, Big 4 Firms, FinTechs, MNCs, Regulatory Bodies, and Financial Institutions</strong>.</>,

        <>Develop practical expertise in <strong>AML, KYC, Customer Due Diligence (CDD), Enhanced Due Diligence (EDD), Sanctions, Transaction Monitoring, Terrorist Financing, and Regulatory Compliance</strong>.</>,

        <>Highly valued by employers seeking professionals for <strong>Financial Crime Compliance, AML Investigations, Risk Management, and Compliance Leadership</strong>.</>,

        <>Future-ready, <strong>AI-resilient career</strong> requiring critical thinking, regulatory knowledge, and investigative expertise.</>,

        <>Prepare and become <strong>exam-ready within 3–4 months</strong> through structured coaching and expert mentorship.</>,

        <>Unlock <strong>global career opportunities</strong> with one of the most respected AML certifications in the financial services industry.</>,
    ];

    const whyTexts = [
        "Kerala's First and Only CAMS coaching provider",
        "One of the most affordable CAMS coaching programs in India",
        "Expert faculty with extensive AML and Financial Crime industry experience",
        "Updated ACAMS-aligned study materials and structured learning plans",
        "Realistic mock exams and chapter-wise practice questions",
        "Complete guidance from eligibility assessment to CAMS certification",
        "Specialized training in AML, KYC, CDD, EDD, Sanctions, and Transaction Monitoring",
        "Strong placement support for opportunities in Big 4 Firms, Global Banks, FinTechs, and MNCs",
        "100% Placement Assistance",
        "Premium Online & Offline Batches (Malayalam & English)",
        "Mentorship from Big 4, Banking, AML, and Financial Crime Compliance Professionals",
        "Resume building, LinkedIn optimization, interview preparation, and career mentoring",
    ];

    const faqs = [
        {
            key: "whatIsCAMS",
            q: "Q1: What is the Certified Anti-Money Laundering Specialist (CAMS) certification?",
            a: "The Certified Anti-Money Laundering Specialist (CAMS) is the world's leading AML certification offered by ACAMS. It validates your expertise in Anti-Money Laundering (AML), Know Your Customer (KYC), Customer Due Diligence (CDD), Sanctions Compliance, Financial Crime Prevention, and Regulatory Compliance.",
        },
        {
            key: "whoShouldPursue",
            q: "Q2: Who should pursue the CAMS certification?",
            a: "CAMS is ideal for banking professionals, AML/KYC analysts, compliance officers, fraud investigators, auditors, risk professionals, accountants, lawyers, law enforcement officers, finance professionals, and graduates aspiring to build a career in AML and financial crime compliance.",
        },
        {
            key: "recognizedGlobally",
            q: "Q3: Is CAMS recognized globally?",
            a: "Yes. CAMS is the world's most recognized AML certification, accepted by employers across 180+ countries and territories.",
        },
        {
            key: "eligibilityRequirements",
            q: "Q4: What are the eligibility requirements for CAMS?",
            a: "Candidates must earn the required 40 eligibility credits through a combination of education, professional experience, and training, along with an active ACAMS membership.",
        },
        {
            key: "freshGraduates",
            q: "Q5: Can fresh graduates apply for CAMS?",
            a: "Yes. Graduates who meet the ACAMS eligibility requirements can pursue the CAMS certification.",
        },
        {
            key: "howLongPrepare",
            q: "Q6: How long does it take to prepare for the CAMS exam?",
            a: "Most candidates prepare for the CAMS examination within 3–4 months with structured coaching and a consistent study plan.",
        },
        {
            key: "topicsCovered",
            q: "Q7: What topics are covered in the CAMS exam?",
            a: (
                <>
                    <p>The CAMS syllabus covers:</p>
                    <ul>
                        <li>Anti-Money Laundering (AML)</li>
                        <li>Know Your Customer (KYC)</li>
                        <li>Customer Due Diligence (CDD)</li>
                        <li>Enhanced Due Diligence (EDD)</li>
                        <li>Transaction Monitoring</li>
                        <li>Sanctions Compliance</li>
                        <li>Suspicious Activity Reporting (SAR)</li>
                        <li>Terrorist Financing</li>
                        <li>FATF Recommendations</li>
                        <li>AML Compliance Programs</li>
                    </ul>
                </>
            ),
        },
        {
            key: "examPattern",
            q: "Q8: What is the CAMS exam pattern?",
            a: "The CAMS exam consists of 120 multiple-choice questions, is 3.5 hours long, and is conducted online or at Pearson VUE testing centers.",
        },
        {
            key: "passingScore",
            q: "Q9: What is the passing score for the CAMS exam?",
            a: "Candidates must achieve the minimum scaled passing score specified by ACAMS to earn the CAMS certification.",
        },
        {
            key: "conductedOnline",
            q: "Q10: Is the CAMS exam conducted online?",
            a: "Yes. The CAMS examination can be taken through online remote proctoring or at an authorized Pearson VUE Test Center.",
        },
        {
            key: "careerOpportunities",
            q: "Q11: What career opportunities are available after CAMS?",
            a: (
                <>
                    <p>CAMS-certified professionals can work as:</p>
                    <ul>
                        <li>AML Analyst</li>
                        <li>AML Compliance Officer</li>
                        <li>KYC/CDD Analyst</li>
                        <li>Transaction Monitoring Analyst</li>
                        <li>Sanctions Analyst</li>
                        <li>Financial Crime Analyst</li>
                        <li>AML Investigator</li>
                        <li>Compliance Officer</li>
                        <li>Risk Analyst</li>
                        <li>AML Consultant</li>
                    </ul>
                </>
            ),
        },
        {
            key: "whichCompanies",
            q: "Q12: Which companies hire CAMS-certified professionals?",
            a: "Leading global banks, Big 4 firms, FinTech companies, MNCs, NBFCs, insurance companies, payment service providers, consulting firms, cryptocurrency companies, and regulatory authorities actively recruit CAMS-certified professionals.",
        },
        {
            key: "worthPursuing",
            q: "Q13: Is CAMS worth pursuing?",
            a: "Yes. CAMS is considered the gold standard in AML certifications and is highly valued by employers worldwide for AML, compliance, and financial crime roles.",
        },
        {
            key: "camsVsCfcs",
            q: "Q14: What is the difference between CAMS and CFCS?",
            a: "CAMS focuses specifically on Anti-Money Laundering (AML) and compliance, while CFCS covers a broader range of financial crime topics, including fraud, cybercrime, corruption, sanctions, and investigations.",
        },
        {
            key: "camsVsCfe",
            q: "Q15: What is the difference between CAMS and CFE?",
            a: "CFE specializes in fraud examination and investigations, whereas CAMS focuses on AML regulations, KYC, sanctions, transaction monitoring, and AML compliance.",
        },
        {
            key: "workExperienceMandatory",
            q: "Q16: Is work experience mandatory for CAMS?",
            a: "Not necessarily. Eligibility is determined by earning the required credits through education, work experience, and professional training.",
        },
        {
            key: "howMuchCost",
            q: "Q17: How much does the CAMS certification cost?",
            a: "The certification fee varies depending on your ACAMS membership category. Contact Meantoir Global Academy for the latest pricing and enrollment assistance.",
        },
        {
            key: "doesMeantoirProvide",
            q: "Q18: Does Meantoir Global Academy provide CAMS coaching?",
            a: "Yes. Meantoir Global Academy, Kochi, offers comprehensive CAMS coaching with expert faculty, updated study materials, mock exams, and career guidance.",
        },
        {
            key: "placementAssistance",
            q: "Q19: Does Meantoir provide placement assistance?",
            a: "Yes. We provide 100% placement assistance, including resume preparation, LinkedIn profile optimization, interview coaching, and career guidance.",
        },
        {
            key: "whyChooseMeantoir",
            q: "Q20: Why choose Meantoir Global Academy for CAMS coaching?",
            a: "Meantoir offers expert faculty, ACAMS-aligned study materials, realistic mock exams, flexible online & offline batches (English & Malayalam), career mentoring, free eligibility assessment, and end-to-end certification support.",
        },
        {
            key: "attendOnline",
            q: "Q21: Can I attend CAMS classes online?",
            a: "Yes. We offer live online classes along with classroom training, enabling professionals across India and abroad to prepare for the CAMS examination.",
        },
        {
            key: "studyMaterials",
            q: "Q22: Do you provide study materials and mock tests?",
            a: "Yes. Students receive comprehensive study materials, chapter-wise practice questions, full-length mock exams, revision sessions, and exam strategies.",
        },
        {
            key: "whoCanPursue",
            q: "Q23: Can CA, ACCA, CPA, CMA, CS, MBA, and law graduates pursue CAMS?",
            a: "Absolutely. CAMS is highly beneficial for CA, ACCA, CPA, CMA, CS, MBA, B.Com, M.Com, law graduates, auditors, bankers, and finance professionals seeking careers in AML and financial crime compliance.",
        },
        {
            key: "jobAbroad",
            q: "Q24: Can CAMS help me get a job abroad?",
            a: "Yes. Since CAMS is globally recognized, it significantly enhances your profile for AML, compliance, and financial crime roles with multinational organizations worldwide.",
        },
        {
            key: "howToEnroll",
            q: "Q25: How do I enroll for CAMS coaching at Meantoir Global Academy?",
            a: "Simply contact Meantoir Global Academy for a FREE CAMS eligibility assessment, personalized counseling, upcoming batch schedules, and enrollment assistance. Our experts will guide you throughout your CAMS certification journey.",
        },
    ];

    return (
        <div>
            <Header />
            <div className="course-page-container">
                <div className="course-hero">
                    <img src={courseback} alt="CAMS course Kerala" className="course-hero-image" />
                    <div className="course-hero-overlay"></div>

                    <div className="course-hero-inner">
                        {/* Left Content */}
                        <div className="course-hero-content left-content">
                            <h1>
                                {isLoading
                                    ? "Loading..."
                                    : courseDetails?.course_title
                                        ?.replace(/\s*\(.*?\)/, "") || "Certified Anti-Money Laundering Specialist Course"}

                                {!isLoading && courseDetails?.course_title?.match(/\(.*?\)/) && (
                                    <h1>
                                        {courseDetails.course_title.match(/\(.*?\)/)?.[0]}
                                    </h1>
                                )}
                            </h1>
                            <i>(World's Leading Anti-Money Laundering Certification)</i>
                            <p>{courseDetails?.course_duration || "1 Exam | 3–4 Months"}</p>
                            <p>
                                Earn up to ₹12+ LPA in just 4 months!  <br />
                                Jobs at Big 4, Global Banks, MNCs & FinTech Companies
                            </p>

                            <Button
                                className="courseCard-button primary-button"
                                type="primary"
                                onClick={(e) => showModal(id!, e)}
                            >
                                Enroll Now
                            </Button>

                            {isModalVisible && (
                                <EnrollModal
                                    visible={isModalVisible}
                                    onClose={handleCloseModal}
                                    courseId={selectedCourseForEnroll}
                                />
                            )}
                        </div>

                        {/* Right Form */}
                        <div className="course-hero-content right-form">
                            <h2>  Make an Enquiry</h2>
                            <Form
                                form={form}
                                layout="vertical"
                                onFinish={submitHandler}
                                initialValues={{
                                    name: '',
                                    phone: '',
                                    email: '',
                                    message: '',
                                }}
                            >
                                <Row gutter={24}>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Name"
                                            name="name"
                                            rules={[{ required: true, message: 'Please enter your name' }]}
                                        >
                                            <Input placeholder="Your Name" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Phone"
                                            name="phone"
                                            rules={[{ required: true, message: 'Please enter your phone' }]}
                                        >
                                            <Input placeholder="Your phone" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Email"
                                            name="email"
                                            rules={[{ required: true, message: 'Please enter your email' }]}
                                        >
                                            <Input type="email" placeholder="Email Address" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Message"
                                            name="message"
                                            rules={[{ required: true, message: 'Please enter your message' }]}
                                        >
                                            <Input.TextArea rows={3} placeholder="Your message" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <FormItem>
                                    <Button type="primary" htmlType="submit">Submit</Button>
                                </FormItem>
                            </Form>
                        </div>
                    </div>
                </div>

                <div className='main-section-course' style={{ padding: "20px" }}>
                    <div className='course-details-section'>
                        <div className='course-details-text'>
                            {/* <ul className="course-details-description">
                                {Array.isArray(description) ? description.join(" ") : description || ""}
                            </ul> */}
                            <ul style={{ listStyle: "none" }} className="course-details-description">
                                {courseDetails?.course_description?.map((desc: string, idx: number) => (
                                    <li key={idx} dangerouslySetInnerHTML={{ __html: desc }} />
                                ))}
                            </ul>

                        </div>
                        <div className="course-details-image">
                            <img
                                src={courseDetails?.course_certificate_image || defalut}
                                alt="CAMS course Kerala"
                                style={{
                                    height: '400px',
                                    width: '90%',
                                    objectFit: 'contain',
                                }}
                            />
                        </div>


                    </div>

                    <div>
                        <br />
                        <h2 className="homepage-heading">About Certified Anti-Money Laundering Specialist</h2>


                        <div className="course-details-tabs-container">
                            <div className="course-details-tabs">
                                <Tabs
                                    activeKey={activeTab}
                                    onChange={setActiveTab}
                                    type="card"
                                    className="custom-tabs"
                                    items={tabItems}
                                    centered
                                />
                            </div>
                        </div>


                        <Modal
                            title="Check Eligibility"
                            open={isEligibilityModalOpen}
                            onCancel={() => setIsEligibilityModalOpen(false)}
                            footer={null}
                            width={600}
                        >
                            <EligibilityCheckForm
                                courseId={id ? Number(id) : 0}
                                onClose={() => setIsEligibilityModalOpen(false)}
                            />
                        </Modal>
                    </div>

                </div>
                <div className="home-why-wrapper">
                    <div className="home-why-container">
                        <div className="home-why-left">
                            <img src={whycfe} alt="AML certification course India" className="home-why-image" />
                        </div>
                        <div className="home-why-right">
                            <h2 className="homepage-heading">Why Certified Anti-Money Laundering Specialist (CAMS)?  </h2>
                            <ul className="home-why-list">
                                {whycamstexts.map((text, index) => (
                                    <li key={index} className="home-why-list-item"> {text}</li>
                                ))}
                            </ul>

                        </div>
                    </div>
                </div>
                <div className="home-why-wrapper">
                    <div className="home-why-container">
                        <div className="home-why-left">
                            <h2 className="homepage-heading">Why Meantoir? </h2>
                            <ul className="home-why-list">
                                {whyTexts.map((text, index) => (
                                    <li key={index} className="home-why-list-item"> {text}</li>
                                ))}
                            </ul>
                        </div>
                        <div className="home-why-right">
                            <img src={why1} alt="AML certification course India" className="home-why-image" />
                        </div>
                    </div>
                </div>
                <div className="ea-section-container">

                    <div>


                        <div style={{ textAlign: "center" }}>
                            <h2 style={{ width: "100%", textAlign: "center", fontSize: "2.5rem", }}>Frequently Asked Questions(FAQ's)</h2>
                        </div>
                        <div>
                            {faqs.map((faq) => (
                                <div key={faq.key}>
                                    <h3
                                        onClick={() => toggleSection(faq.key)}
                                        style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}
                                    >
                                        {faq.q}
                                    </h3>
                                    {openSection === faq.key && (
                                        <p style={{ width: "100%", fontSize: "1.5rem", }}>
                                            {faq.a}
                                        </p>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <h2 className="homepage-heading">Explore More Courses</h2>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>

                    <CourseDisplayCard />
                </div>

            </div>
            <Footer />
        </div>
    );
}

export default Cams;
